import { IAppProps } from '../interface/IAppProvider';

export enum HTTP_METHOD {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
}

interface IHeaderProperties {
    [key: string]: string;
}

interface IEndPointHeader {
    cvr: IHeaderProperties;
    wso2: IHeaderProperties;
    tilbudsflow: IHeaderProperties;
    objectCache: IHeaderProperties;
    wso2Secured: IHeaderProperties;
}

const getHeaders = (filterKey: keyof IEndPointHeader, props: IAppProps) => {
    const endpointHeaders = {
        wso2: {
            'x-top-host': props.config.wso2ApiHost,
            'x-top-appname': props.config.appName,
        },
        tilbudsflow: {
            'x-top-host': `tilbudsflow${props.config.environment}.topdanmark.local`,
            'x-top-brand': 'td',
            'x-top-appname': props.config.appName,
        },
        wso2Secured: {
            'x-top-host': props.config.wso2ApiHost,
            'x-top-port': '80',
            'x-top-appname': props.config.appName,
        },
        cvr: {
            'x-top-environment': props.config.environment,
            'x-top-appname': props.config.appName,
        },
        objectCache: {
            'x-top-appname': props.config.appName,
        },
    };
    return endpointHeaders[filterKey];
};

export const getDefaultOptions = (
    method: HTTP_METHOD,
    props: IAppProps,
    endPoint: keyof IEndPointHeader,
    body?: object,
): RequestInit => {
    const options: RequestInit = {
        method: method,
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const newHeaders = getHeaders(endPoint, props);
    if (body) {
        options.body = JSON.stringify(body);
    }
    options.headers = { ...options.headers, ...newHeaders };
    return options;
};
